<template>
  <div>
    <div class="layout debt-report">
      <link-modal ref="linkModal" title="Ссылка на Google Таблицы"></link-modal>

      <div class="layout-header">
        <div class="layout-title">Отчет по остатку задолженности</div>

        <div class="layout-header-actions">
          <div class="layout-header-action">
            <c-button
              size="small"
              :icon="{
                icon: 'bookmark',
                activeColor: 'white',
              }"
              :tooltip="{
                text: 'Добавить в закладки',
                activeText: 'Убрать из закладок',
              }"
              active-color="blue"
              :active="bookmark"
              @click="bookmark = !bookmark"
            />
          </div>

          <div class="layout-header-action">
            <google-form :sp="sp"></google-form>
          </div>
        </div>
      </div>

      <debt-report-filters
        ref="filters"
        class="debt-report__filters"
        @apply="applyFilters"
        @inited="filtersInited = true"
      />

      <c-tabs :items="tabsItems" with-routing />

      <div v-if="filtersInited" class="debt-content">
        <router-view
          ref="table"
          :workers="workers"
          :charts-data="chartsData"
          :loading="loading"
          :page="page"
          :filters-ref="$refs.filters"
          @apply="applyFilters"
          @nextPage="nextPage"
          @inited="onComponentInit"
        />
      </div>

      <c-loader v-else class="mt-4" label="Данные загружаются" :active="!filtersInited" height="300" />
    </div>

    <top-button root=".layout"></top-button>
  </div>
</template>

<script>
import Button from "@/components/controls2/Button";
import TopButton from "@/components/top-button";
import Tabs from "@/components/tabs";
import Loader from "@/components/loader";

import DebtReportFilters from "./components/filters/index";
import GoogleForm from "./components/google/index";

import LinkModal from "@/components/modals/link-modal";

import { WorkerModel } from "@/entities/models/worker";

export default {
  name: "debt-report",

  components: {
    "c-button": Button,
    "c-tabs": Tabs,
    "c-loader": Loader,

    TopButton,
    LinkModal,

    "debt-report-filters": DebtReportFilters,
    GoogleForm,
  },

  data() {
    return {
      bookmark: false,
      defaultFilters: {},

      googlePending: false,

      filtersInited: false,
      tableInited: false,

      sp: {},

      loading: false,
      lastRequestEmpty: false,
      workers: [],
      chartsData: {
        filials: {
          result: [],
          sum_all: 0,
        },
        positions: {
          result: [],
          sum_all: 0,
        },
      },
      page: 1,
      queryParams: {},
    };
  },

  computed: {
    dataInited() {
      return this.filtersInited && this.tableInited;
    },
    currentRouteName() {
      return this.$route.name;
    },
    tabsItems() {
      return [
        { label: "Список сотрудников", value: "debt-employees-list", query: this.queryParams },
        { label: "Отчеты", value: "debt-reports", query: this.queryParams },
      ];
    },
  },

  watch: {
    dataInited(v) {
      if (v) this.load();
    },
  },

  methods: {
    // applyFiltersFromChild(filtersData) {
    //   this.applyFilters(filtersData)
    // },
    getParams() {
      const filters = this.$refs.filters.getParams();

      let params = {
        filters,
      };

      if (this.currentRouteName === "debt-employees-list") {
        const { filters: columnFilters, sortBy, desc } = this.$refs.table.getParams();

        params = {
          ...params,
          columnFilters,
          sort_by: sortBy,
          sort_type: desc ? "desc" : "asc",
          page: this.page,
        };
      }

      this.sp = params;

      return params;
    },
    onComponentInit() {
      this.tableInited = true;
      this.load();
    },

    load() {
      if (this.loading) return;

      this.loading = true;
      const params = this.getParams();

      this.updateUrl();

      if (this.currentRouteName === "debt-employees-list") {
        this.$store.dispatch("debtReport/loadWorkers", params).then((res) => {
          if (!res.workers || !res.workers.length) {
            this.lastRequestEmpty = true;
          }
          this.workers = [...this.workers, ...(res.workers || []).map((item) => new WorkerModel(item))];
          this.loading = false;
        });
      }

      if (this.currentRouteName === "debt-reports") {
        Promise.all([
          this.$store.dispatch("debtReport/loadChartDataByFilials", params).then((res) => {
            this.chartsData.filials = res;
          }),
          this.$store.dispatch("debtReport/loadChartDataByPositions", params).then((res) => {
            this.chartsData.positions = res;
          }),
        ]).finally(() => {
          this.loading = false;
        });
      }
    },

    updateUrl() {
      const filters = this.$refs.filters.getUrlParams();

      const query = {
        ...this.$route.query,
        ...filters,
      };

      if (this.currentRouteName === "debt-employees-list") {
        const table = this.$refs.table.getUrlParams();

        Object.entries(table).forEach(([key, value]) => {
          if (value) {
            query[key] = value;
          } else {
            delete query[key];
          }
        });
      }

      this.queryParams = query;

      this.$router
        .replace({
          name: this.currentRouteName,
          query,
        })
        .catch(() => {})
        .finally(() => {});
    },

    applyFilters(reportsFilterData) {
      this.lastRequestEmpty = false;
      this.page = 1;
      this.workers = [];
      this.load(reportsFilterData);
    },

    resetFilters() {
      this.$refs.filters.reset();
    },

    resetTableFilters() {
      if (this.currentRouteName === "debt-employees-list") {
        this.$refs.table.resetFilters();
      }
    },

    nextPage() {
      if (this.lastRequestEmpty) return;
      this.page += 1;
      this.load();
    },

    toGoogleSpreadsheet() {
      this.googlePending = true;
      const params = this.getParams();
      this.$store.dispatch("debtReport/toGoogleSpreadsheet", params).then((res) => {
        this.$refs.linkModal.open(res.url);
        this.googlePending = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.debt-report {
  &__table {
    margin-top: 30px;
    margin-bottom: 30px;
  }

  @include onlyMobile {
    padding-top: 25px;
  }
}

.debt-content {
  padding-top: 30px;
  @include onlyExtraSmall {
    padding-top: 20px;
  }
}
</style>
